const getSelectedLocale = state => {
  return state.dashboard?.language || state.app?.locale;
};

export default getSelectedLocale;
